import React from "react";

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="bg-zinc-950 text-zinc-300"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16 py-14 md:py-16">
        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-6">
            <div className="flex items-center gap-2">
              <span className="inline-flex h-9 w-9 items-center justify-center rounded-lg bg-white text-zinc-900 font-heading font-bold text-sm">
                MS
              </span>
              <span className="font-heading text-lg font-semibold text-white">
                My Smart Delegate
              </span>
            </div>
            <p className="mt-5 text-zinc-400 max-w-md leading-relaxed">
              Helping creators turn their audience into revenue &mdash; one well-built digital product at a time.
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="text-xs uppercase tracking-[0.2em] font-semibold text-zinc-500 mb-4">
              Contact
            </div>
            <a
              data-testid="footer-email"
              href="mailto:mysmartdelegate@gmail.com"
              className="block text-zinc-200 hover:text-white transition-colors"
            >
              mysmartdelegate@gmail.com
            </a>
            <a
              data-testid="footer-phone"
              href="tel:+40784699771"
              className="block mt-2 text-zinc-200 hover:text-white transition-colors"
            >
              +40 784699771
            </a>
          </div>

          <div className="md:col-span-3">
            <div className="text-xs uppercase tracking-[0.2em] font-semibold text-zinc-500 mb-4">
              Sections
            </div>
            <div className="flex flex-col gap-2 text-zinc-300">
              <a href="#about" className="hover:text-white transition-colors">About</a>
              <a href="#services" className="hover:text-white transition-colors">Services</a>
              <a href="#why" className="hover:text-white transition-colors">Why it matters</a>
              <a href="#contact" className="hover:text-white transition-colors">Contact</a>
            </div>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-zinc-800 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 text-sm text-zinc-500">
          <div>&copy; {new Date().getFullYear()} My Smart Delegate. All rights reserved.</div>
          <div>Built simply. Built to convert.</div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
